import { combineReducers } from 'redux';
import { cart } from './Reducers/Cart.reducer';
import { navigation } from './Reducers/Navigation.reducer';
import { facetedSearch } from './Reducers/FacetedSearch.reducer';
import { checkout } from './ReducersBrafab/Checkout.reducer';
import { myPage } from './ReducersBrafab/MyPage.reducer';
import { channels } from './ReducersBrafab/Channels.reducer';
import { quickSearch } from './ReducersBrafab/QuickSearch.reducer';
import { favourites } from './ReducersBrafab/Favourites.reducer';
import { searchTabs } from './ReducersBrafab/SearchTabs.reducer';
import { offerPage } from './ReducersBrafab/OfferPage.reducer';
import { consumerOrderTexts } from './ReducersBrafab/ConsumerOrderTexts.reducer';

const staticReducers = {
    cart,
    quickSearch,
    navigation,
    facetedSearch,
    checkout,
    myPage,
    channels,
    favourites,
    offerPage,
    searchTabs,
    consumerOrderTexts
  };

const app = combineReducers(staticReducers);

export const createReducer = (asyncReducers) => {
  return combineReducers({
    ...staticReducers,
    ...asyncReducers,
  });
};

export default app;
